import { Text } from "../Text";
import { useSelector } from "react-redux";
import { resolveBrandDisplayName } from "../../utils/brandingUtils";
function Footer() {
  const companyConfig = useSelector((state) => state?.whitelabel?.companyData?.data);
  const brandName = resolveBrandDisplayName(companyConfig);
  const rightsUrl = companyConfig?.rights || companyConfig?.title || companyConfig?.name || "";
  const termsUrl = companyConfig?.termsConditionLink || "";

  return (
    <div className="py-3 px-5" style={{ borderTop: "1px solid #E1E1EA" }}>
      <div className="flex flex column md:flex-row lg:flex-row xl:flex-row align-items-center  justify-content-center md:justify-content-between lg:justify-content-between xl:justify-content-between gap-1 flex-wrap">
        <Text type={"small-text"} color={"#5E5E72"}>
          <span>
            &copy; {new Date().getFullYear()} {rightsUrl || "Deskala"}, All
            Rights Reserved.
          </span>
        </Text>
        <Text type={"small-text"}>
          <a
            href={termsUrl || "https://skalebot.com/termsandconditions"}
            target="_blank"
            rel="noreferrer"
            style={{ color: "#5E5E72", textDecoration: "none" }}
          >
            Terms & Conditions {termsUrl ? '' : `| ${brandName}`}
          </a>
        </Text>
      </div>
    </div>
  );
}

export default Footer;
